export default "__VITE_ASSET__Ck_Wn8xo__"